import { render, staticRenderFns } from "./VisionCameraCapture.vue?vue&type=template&id=509e4651&scoped=true&"
import script from "./VisionCameraCapture.vue?vue&type=script&lang=js&"
export * from "./VisionCameraCapture.vue?vue&type=script&lang=js&"
import style0 from "./VisionCameraCapture.vue?vue&type=style&index=0&id=509e4651&prod&lang=css&"
import style1 from "./VisionCameraCapture.vue?vue&type=style&index=1&id=509e4651&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e4651",
  null
  
)

export default component.exports